import { Container, makeStyles } from '@material-ui/core';
import React, { useEffect } from 'react';
import { useState } from 'react';
import NewEntryControl from '../../components/NewEntryControl';
import { PRIOR, AFTER } from '../../config/staticValues';
import TimecardNavigation from './TimecardNavigation';
import Workday from './Workday';
import EntryModal from './EntryModal';
import TimecardDatasheet from './TimecardDatasheet';
import dateUtil from '../../util/dateUtil';
import { useSelector } from 'react-redux';
import Visible from '../../components/Visible';

const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: '75px',
    [theme.breakpoints.down('xs')]: {
      marginTop: '0px',
    },
  },
}));

const Timecard = () => {
  const timecard = useSelector((state) => state.timecard);
  const timecardId = useSelector((state) => state.general.timecardId);
  const classes = useStyles();
  const workdays = timecard.workdays;
  const entries = timecard.entries;
  const [activeDay, setActiveDay] = useState();
  const [isTimelineView, setIsTimelineView] = useState(true);
  const clickSetActiveDay = (value) => {
    setActiveDay(value);
  };
  const toggleTimelineView = () => {
    setIsTimelineView(!isTimelineView);
  };

  const isDisabled = timecard.status != 'DRAFT';

  //Once timecard is loaded set the active day so on load scroll occurs
  useEffect(() => {
    if (timecard.timecardId) setActiveDay(getCorrectDate());
  }, [timecard, timecard.timecardId, timecardId]);

  const getCorrectDate = () => {
    if (dateUtil.isBeforeToday(timecard.endDate)) return timecard.endDate;
    return dateUtil.nowShortDateString();
  };

  if (!timecard.timecardId || !activeDay) return '';
  const priorEntries = entries.filter(
    (entry) => !entry.startDate || dateUtil.isBefore(entry.startDate, timecard.startDate)
  );
  const afterEntries = entries.filter(
    (entry) => entry.startDate && dateUtil.isAfter(entry.startDate, timecard.endDate)
  );
  return (
    <Container className={classes.root}>
      <Visible smUp>
        <TimecardNavigation
          activeDay={activeDay}
          setActiveDay={clickSetActiveDay}
          isTimelineView={isTimelineView}
          toggleTimelineView={toggleTimelineView}
          showPriorButton={priorEntries.length > 0}
          timecardStatus={timecard.status}
          className=".xs-hidden"
        />
      </Visible>
      <div className={classes.container}>
        {isTimelineView ? (
          <>
            {priorEntries.length > 0 && (
              <Workday
                workday={{ workDate: PRIOR }}
                entries={priorEntries}
                activeDay={activeDay}
                setActiveDay={setActiveDay}
                isPriorWorkday={true}
                disabed={isDisabled}
              />
            )}
            {afterEntries.length > 0 && (
              <Workday
                workday={{ workDate: AFTER }}
                entries={afterEntries}
                activeDay={activeDay}
                setActiveDay={setActiveDay}
                isAfterWorkday={true}
                disabed={isDisabled}
              />
            )}
            {workdays.map((workday, index) => {
              const workdayEntries = entries.filter((entry) => {
                return dateUtil.isSameDay(entry.startDate, workday.workDate);
              });
              return (
                <Workday
                  key={index}
                  workday={workday}
                  entries={workdayEntries}
                  activeDay={activeDay}
                  setActiveDay={setActiveDay}
                  disabled={isDisabled}
                />
              );
            })}
          </>
        ) : (
          <TimecardDatasheet
            timecard={timecard}
            disabled={isDisabled}
            key={timecard.timecardId}
          />
        )}
        {!isDisabled && <NewEntryControl />}
        <EntryModal disabled={isDisabled} />
      </div>
    </Container>
  );
};

export default Timecard;
